/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**

  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav.

  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import ResourcePage from "layouts/admin/ResourcePage";
import CountriesPage from "layouts/admin/CountriesPage";
import ChecklistPage from "layouts/admin/ChecklistPage";
import ContactMessagesPage from "layouts/admin/ContactMessagesPage";
import ArticlesPage from "layouts/admin/ArticlesPage";
import AppSettingsPage from "layouts/admin/AppSettingsPage";
import TranslationSettingsPage from "layouts/admin/TranslationSettingsPage";
import AnalyticsPage from "layouts/admin/AnalyticsPage";
import SocialPublisherPage from "layouts/admin/SocialPublisherPage";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "آخر الأخبار",
    key: "articles",
    icon: <Icon fontSize="small">auto_awesome</Icon>,
    route: "/articles",
    component: <ArticlesPage />,
  },
  {
    type: "collapse",
    name: "الرئيسية",
    key: "dashboard",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "النمو والتحليلات",
    key: "analytics",
    icon: <Icon fontSize="small">insights</Icon>,
    route: "/analytics",
    component: <AnalyticsPage />,
  },
  {
    type: "collapse",
    name: "النشر الاجتماعي",
    key: "social",
    adminOnly: true,
    icon: <Icon fontSize="small">campaign</Icon>,
    route: "/social",
    component: <SocialPublisherPage />,
  },
  {
    type: "collapse",
    name: "يا مسافر Moment",
    key: "monthly-events",
    adminOnly: true,
    icon: <Icon fontSize="small">event</Icon>,
    route: "/monthly-events",
    component: <ResourcePage resource="monthly-events" />,
  },
  { type: "title", title: "إدارة المحتوى", key: "content" },
  {
    type: "collapse",
    name: "الدول والمدن",
    key: "countries",
    icon: <Icon fontSize="small">public</Icon>,
    route: "/countries",
    component: <CountriesPage />,
  },
  {
    type: "collapse",
    name: "التنبيهات",
    key: "notices",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notices",
    component: <ResourcePage resource="notices" />,
  },
  {
    type: "collapse",
    name: "تجهيزات السفر",
    key: "checklist-templates",
    icon: <Icon fontSize="small">checklist</Icon>,
    route: "/checklist-templates",
    component: <ChecklistPage />,
  },
  { type: "title", title: "خدمة المسافرين", key: "travellers" },
  {
    type: "collapse",
    name: "رسائل المسافرين",
    key: "contact-messages",
    adminOnly: true,
    icon: <Icon fontSize="small">mail</Icon>,
    route: "/contact-messages",
    component: <ContactMessagesPage />,
  },
  {
    type: "collapse",
    name: "المستخدمون",
    key: "users",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/users",
    component: <ResourcePage resource="users" />,
  },
  {
    type: "collapse",
    name: "الرحلات والدعم",
    key: "trips",
    icon: <Icon fontSize="small">flight_takeoff</Icon>,
    route: "/trips",
    component: <ResourcePage resource="trips" />,
  },
  {
    type: "title",
    title: "إدارة النظام",
    key: "system",
  },
  {
    type: "collapse",
    name: "مترجم السفر",
    key: "translation-settings",
    adminOnly: true,
    icon: <Icon fontSize="small">translate</Icon>,
    route: "/translation-settings",
    component: <TranslationSettingsPage />,
  },
  {
    type: "collapse",
    name: "إعدادات الرئيسية",
    key: "app-settings",
    adminOnly: true,
    icon: <Icon fontSize="small">tune</Icon>,
    route: "/app-settings",
    component: <AppSettingsPage />,
  },
  {
    type: "collapse",
    name: "سجل التدقيق",
    key: "audit",
    adminOnly: true,
    icon: <Icon fontSize="small">history</Icon>,
    route: "/audit",
    component: <ResourcePage resource="audit" />,
  },
  {
    type: "collapse",
    name: "فريق الإدارة",
    key: "admin-users",
    adminOnly: true,
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/admin-users",
    component: <ResourcePage resource="admin-users" />,
  },
];

export default routes;
